import request from '@/utils/request'

let fareApi = {
  /*订单结算比例查询*/
  getSettlementProportion(data, errorback) {
    return request._post('/shop/config/getSettlementProportion', data, errorback);
  },
  /*订单结算比例设置*/
  editSettlementProportion(data, errorback) {
    return request._post('/shop/config/editSettlementProportion', data, errorback);
  },
  /*车费设置查询*/
  getFare(data, errorback) {
    return request._post('/shop/config/getFare', data, errorback);
  },
  /*车费设置*/
  editFare(data, errorback) {
    return request._post('/shop/config/editFare', data, errorback);
  },
  // 订单设置
  getorderData(data, errorback) {
    return request._get('/shop/setting.scale/index', data, errorback);
  },
  postorderData(data, errorback) {
    return request._post('/shop/setting.scale/index', data, errorback);
  },
  /*退款比例修改*/
  Refundedit(data, errorback) {
    return request._post('/shop/setting.Refund/index', data, errorback);
  },
  /*退款比例详情*/
  Refundindex(data, errorback) {
    return request._get('/shop/setting.Refund/index', data, errorback);
  },
  /*加钟比例修改*/
  AddClockedit(data, errorback) {
    return request._post('/shop/setting.AddClock/index', data, errorback);
  },
  /*加钟比例详情*/
  AddClockindex(data, errorback) {
    return request._get('/shop/setting.AddClock/index', data, errorback);
  },
  // 车费设置
  fareList(data, errorback) {
    return request._post('/shop/order.fare/list', data, errorback);
  },
  /*车费设置列表*/
  fareDetail(data, errorback) {
    return request._get('/shop/order.fare/list', data, errorback);
  },
  fareAdd(data, errorback) {
    return request._post('/shop/order.fare/add', data, errorback);
  },
  /*车费设置列表*/
  fareEdit(data, errorback) {
    return request._post('/shop/order.fare/edit', data, errorback);
  },
  /*车费设置列表*/
  fareDel(data, errorback) {
    return request._post('/shop/order.fare/del', data, errorback);
  }
}
export default fareApi;



// WEBPACK FOOTER //
// ./src/api/fare.js